import { render, staticRenderFns } from "./PartnerImageNodeView.vue?vue&type=template&id=0452563c&scoped=true"
import script from "./PartnerImageNodeView.vue?vue&type=script&lang=ts"
export * from "./PartnerImageNodeView.vue?vue&type=script&lang=ts"
import style0 from "./PartnerImageNodeView.vue?vue&type=style&index=0&id=0452563c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452563c",
  null
  
)

export default component.exports